<!--主页-->
<template>
  <el-container class="home-container">
    <!--头部区域-->
    <el-header>
      <div>
        <!--<span>高淳河蟹产业链创新平台</span>-->
        <img src="../../assets/spictures/logo.png" style="width: 200px;height: 60px;">
      </div>
      <!--<el-button type="info" @click="logout">退出</el-button>-->
      <span>欢迎您!超级管理员</span>
      <el-dropdown trigger="click" size="small">
      <span class="el-dropdown-link">
        <el-avatar class="avatar" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <!--左侧区域-->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu background-color="#fff" text-color="#333744" active-text-color="#409eff" unique-opened
                 :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
          <!--左侧菜单栏循环渲染-->
          <el-submenu :index="item.id + ''" v-for="item in menu" :key="item.id">
            <template slot="title">
              <i :class="icons[item.id]"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item :index="sub.path" v-for="sub in item.children" :key="sub.id" @click="saveNavState(sub.path)">
              <i :class="iconsChild[sub.id]"></i>
              <span>{{sub.name}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!--右侧区域-->
      <el-main>
        <!--Welcome组件路由出口-->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import menuList from '../../assets/json/home'
//const request = require('../../http/API')
import request from '../../http/auth'
//const axios = require('axios')
export default {
  name: 'Home',
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  data () {
    return {
      /* 菜单栏是否展开 */
      isCollapse: false,
      /* 存放左侧菜单栏渲染数据 */
      menu: menuList.data,
      /* 存放一级菜单栏渲染图标 */
      icons: {
        '001': 'el-icon-s-shop',
        '002': 'el-icon-notebook-1'
      },
      /* 存放二级菜单栏渲染图标 */
      iconsChild: {
        '0011': 'el-icon-grape',
        '0012': 'el-icon-dessert',
        '0013': 'el-icon-cherry',
        '0014': 'el-icon-sugar',
        '0015': 'el-icon-ice-cream',
        '0021': 'el-icon-s-marketing'
      },
      /*被激活的链接地址*/
      activePath: ''
    }
  },
  methods: {
    /*保存链接的激活状态*/
    saveNavState(activePath){
      window.sessionStorage.setItem('activePath',activePath)
      //console.log(activePath);
      this.activePath = activePath
      //console.log(this.activePath);
    },
   async logout () {
      /* 清楚session缓存并跳转到登录页面 */
      let res = await request.logout()
     console.log(res);
      if (res.data.resultCode === 'SUCCESS'){
        //清空缓存
        window.sessionStorage.clear()
        // 刷新当前页面,回到登录状态
        this.$router.push('/Login')
        location.reload()
      }
    },
    /* 点击按钮,切换菜单的折叠与展开 */
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="less" scoped>
  .home-container{
    height: 100%;
  }
.el-header{
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #333744;
  font-size: 15px;
  > div{
    display: flex;
    align-items: center;
    span{
      margin-left: 15px;
    }
  }
}
  .el-aside{
    background-color: #ffffff;
    .el-menu{
      border-right: none;
    }
  }
  .el-main{
    background-color: #f2f2f2;
  }
  .toggle-button{
    background-color: #ffffff;
    font-size: 10px;
    line-height: 24px;
    color: #4a5064;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
    border: 1px solid  gainsboro;
  }
  .el-dropdown-link {
    cursor: pointer;
  }
  .el-popper[x-placement^=bottom] {
    margin-top: 22px;
    margin-right: 7px;
  }
</style>
